import { DatePicker, DatePickerProps } from '@mui/x-date-pickers-pro';
import { format, isValid, parseISO } from 'date-fns';
import { FormikValues, useFormikContext } from 'formik';

const getValue = (value: Date | string): Date | null => {
  const formDate = value instanceof Date ? value : parseISO(value);
  return isValid(formDate) ? formDate : null;
};

type FormikDatePickerProps = {
  name: string;
  required?: boolean;
  error?: boolean;
  onChange?: (val: Date | null) => void;
};

const FormikDatePicker = <T extends FormikValues>({
  name,
  required,
  error,
  onChange,
  ...otherProps
}: FormikDatePickerProps & DatePickerProps<Date>) => {
  const formik = useFormikContext<T>();

  return (
    <DatePicker
      value={formik.values[name] ? getValue(formik.values[name]) : null}
      {...otherProps}
      slotProps={{
        textField: {
          required,
          error,
          onBlur: () => {
            formik.setFieldTouched(name, true);
          },
          ...otherProps.slotProps?.textField,
        },
        ...otherProps.slotProps,
      }}
      onChange={(val) => {
        const date = val as Date;
        if (isValid(date)) {
          formik.setFieldValue(name, format(date, 'yyyy-MM-dd'));
        }
        formik.setFieldTouched(name, true);
        onChange && onChange(val);
      }}
    />
  );
};

export default FormikDatePicker;
